<template>
	<dialog-slot
			:title="title"
			@updateClose="onClose"
			@updateSave="onSave"
			:width="dialogWidth"
			:z-index="zIndex"
			:dark="isDarkTheme"
			:fullscreen="isFullScreen"
			:is-save="false"
	>
		<template v-if="$slots.subTitle" #subTitle>
			<slot name="subTitle"></slot>
		</template>

		<no-info
				v-if="list && list.length <= 0"
				:text="noInfo"
		/>

		<div v-else class="main">
			<main-table
					v-if="list"
					:key="list.length + flag"
					padding="0 0 10px"
					:flag="flag"
					:uniqId="uniqId"
					:headers="headers"
					:listItems="list"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
					@updateClickButton="onClickButton($event, flag)"
					@updateModEvent="onModEvent"
					:is-last-row="isLastRow"
			></main-table>
		</div>
	</dialog-slot>
</template>

<script>

import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";

export default {
	name: "DialogTable",
	components: { NoInfo, DialogSlot },
	computed: {
		isDarkTheme() {
			// если provide вернул функцию (наш случай) — вызываем её
			if (typeof this.themeIsDark === 'function') {
				return !!this.themeIsDark();
			}
			// если когда-то будет просто boolean — тоже приведём к Boolean
			return !!this.themeIsDark;
		},
		dialogWidth() {
			return this.isFullScreen ? '100%' : this.width;
		}
	},
	props: {
		// isDialog: Boolean,
		uniqId: String,
		title: String,
		list: Array,
		headers: Array,
		flag: String,
		isSave: Boolean,
		noInfo: {
			type: String,
			default: 'The information is missing. Please provide the necessary data.'
		},
		zIndex: {
			type: String,
			default: () => '1000'
		},
		width: {
			type: String,
			default: () => '900px'
		},
		isFullScreen: Boolean,
		isLastRow: Boolean,
	},
	data: () => ({
	}),
	methods: {
		onClose() {
			this.$emit("updateClose");
		},
		onSave() {
			this.$emit("updateSave");
		},
		onClickButton({ key, item }) {
			this.$emit("updateClickButton", { key, item });
		},
		onModEvent(args) {
			this.$emit('updateModEvent', args);
		},

	},
	mounted() {

	}
};
</script>
